import React from 'react';
import { FiAlertTriangle, FiX } from 'react-icons/fi';
import { useNotificaciones } from '../context/NotificacionesContext';

const AlertaCritica = ({ onVer, onVerPedido }) => {
  const { alertaCritica, descartarAlerta, marcarLeidasPorArea } = useNotificaciones();

  if (!alertaCritica) return null;

  const limpiar = () => {
    if (alertaCritica.area) marcarLeidasPorArea(alertaCritica.area);
    descartarAlerta();
  };

  const atender = () => {
    if (alertaCritica.pedidoId && onVerPedido) onVerPedido(alertaCritica.pedidoId);
    else if (alertaCritica.page && onVer) onVer(alertaCritica.page);
    limpiar();
  };

  return (
    <>
      <style>{`@keyframes alertaCriticaIn { from { opacity: 0; transform: translateX(-50%) translateY(-12px); } to { opacity: 1; transform: translateX(-50%) translateY(0); } }`}</style>
      <div style={S.overlay}>
        <div style={S.card}>
          <div style={S.icon}>
            <FiAlertTriangle size={24} color="#b45309" />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={S.titulo}>{alertaCritica.titulo || 'Alerta'}</div>
            <div style={S.mensaje}>{alertaCritica.mensaje || ''}</div>
          </div>
          <button onClick={atender} style={S.btnAtender}>
            Atender
          </button>
          <button onClick={limpiar} style={S.btnCerrar} title="Cerrar">
            <FiX size={18} />
          </button>
        </div>
      </div>
    </>
  );
};

const S = {
  overlay: {
    position: 'fixed',
    top: '16px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 3000,
    width: 'min(560px, calc(100vw - 32px))',
    animation: 'alertaCriticaIn 0.25s ease',
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    padding: '14px 16px',
    borderRadius: '14px',
    background: '#fffbeb',
    border: '1.5px solid #f59e0b',
    boxShadow: '0 12px 40px rgba(0,0,0,0.22)',
    color: '#1f2937',
  },
  icon: {
    width: '44px',
    height: '44px',
    borderRadius: '12px',
    background: '#fef3c7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  titulo: { fontSize: '15px', fontWeight: 700 },
  mensaje: { fontSize: '13px', color: '#6b7280', marginTop: '2px' },
  btnAtender: {
    border: 'none',
    cursor: 'pointer',
    borderRadius: '10px',
    padding: '10px 18px',
    fontSize: '13px',
    fontWeight: 700,
    fontFamily: 'inherit',
    background: '#f59e0b',
    color: '#fff',
    flexShrink: 0,
    transition: 'background 0.15s',
  },
  btnCerrar: {
    border: 'none',
    cursor: 'pointer',
    background: 'transparent',
    color: '#9ca3af',
    padding: '4px',
    display: 'flex',
    flexShrink: 0,
  },
};

export default AlertaCritica;
